import React, {useState} from 'react'
import './style.scss'
import {Button, Form, Input, message} from "antd"
import {resetPassword} from "../../../../services/api/apiUser"

const layout = {
    wrapperCol: {span: 24},
};

const tailLayout = {
    wrapperCol: {span: 24},
};

function ResetPassword() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const linkApp = import.meta.env.REACT_URL_IPCC || 'https://admin.callstack.vn'
    const arrLinkApp = linkApp.split("//")
    const textDomain = arrLinkApp.length > 0 ? arrLinkApp[1] : ''
    if (textDomain) {
        let favicon = "/logo/" + textDomain + "_favicon.ico"
        const faviconElm = document.getElementById("favicon"); // Accessing favicon element
        faviconElm.href = favicon;
    }

    const onReset = () => {
        form.resetFields()
    }

    const onFinish = async (values) => {
        setLoading(true)
        setError('')

        try {
            const response = await resetPassword({...values})
            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            onReset()
            message.success('Vui lòng kiểm tra email để nhận mật khẩu mới')
            setTimeout(() => {
                window.location.href = 'https://admin.callstack.vn'
            }, 3000)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    return (
        <div className="ResetPassword">
            <div className="content">
                <div className="logo">
                    <img src={`/logo/${textDomain}_logo.jpg`} alt="logo"/>
                </div>

                {
                    !!error && error.length > 0 && <div className="error">
                        {error}
                    </div>
                }
                <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
                    <Form.Item
                        name="userName"
                        rules={[{required: true, message: 'Vui lòng nhập user name'}]}
                    >
                        <Input placeholder="Nhập vào user name" prefix={<i className="fa-solid fa-user-headset"/>}/>
                    </Form.Item>
                    <Form.Item
                        name="email"
                        rules={[
                            {required: true, message: 'Vui lòng nhập email'},
                            {type: "email", message: "Vui lòng nhập đúng định dạng email!"}
                        ]}
                    >
                        <Input placeholder="Nhập vào email" prefix={<i className="fa-solid fa-lock-keyhole"/>}/>
                    </Form.Item>
                    <Form.Item {...tailLayout} className="no-border">
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="ButtonCustom"
                            loading={loading}
                            disabled={loading}
                        >
                            Reset password
                        </Button>
                    </Form.Item>

                    <div className="bottom">
                        <a href="https://admin.callstack.vn">Đăng nhập</a>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default ResetPassword
